import { useEffect, useState } from "react";
import { CountForStatus } from "../api/countForStatusApi";
import statusToColor from "../utils/statusToColor";
import { useAppSelector } from "../../../shared/store/store";

type SensorStatusItemProps = CountForStatus & { color: string };

function useSensorStatus() {
    const sensorDatas = useAppSelector(state => state.sensorData);
    const [items, setItems] = useState<SensorStatusItemProps[]>([]);
    
    useEffect(() => {
        const base = [
            { codeId: "TOTAL", codeName: "지도합계" },
            { codeId: "SG001", codeName: "안전" },
            { codeId: "SG002", codeName: "주의" },
            { codeId: "SG003", codeName: "경보" },
            { codeId: "SG004", codeName: "점검" },
        ];
        const newItems = base.map(({ codeId, codeName }) => {
            const statusCnt = codeId === "TOTAL"
                ? sensorDatas.length
                : sensorDatas.filter(sensorData => sensorData.sensorStatusGrp === codeId).length;
            return {
                codeId,
                codeName,
                color: statusToColor(codeName).color,
                statusCnt,
            };
        });
        setItems(newItems);
    }, [sensorDatas]);
    // useEffect(() => {
    //     if(isSuccess) {
    //         let totalCnt = 0;
    //         const newItems = countForStatuses?.map((status)=>{
    //             const item: SensorStatusItemProps = {
    //                 ...status,
    //                 color: statusToColor(status.codeName).color,
    //             }
    //             totalCnt += status.statusCnt;
    //             return item;
    //         });
    //         newItems?.unshift({ codeId:"TOTAL", statusCnt: totalCnt, codeName: "전체", color: "#3E63ED" });
    //         setItems(newItems as SensorStatusItemProps[]);
    //     }
    // }, [
    //     isSuccess
    // ])
    return { items }

}

export type { SensorStatusItemProps };
export default useSensorStatus;
